<template>
  <div
    class=" saved-items-wrapper relative-position"
    style="height: calc(100vh - 43px); padding-right: 9px; backgroound: #ffffff"
    :style="drawerRight && { 'padding-right': '0px' }"
  >
    <div class="loading" v-if="!showIframe">
      <q-circular-progress
        indeterminate
        size="50px"
        :thickness="0.15"
        color="primary"
      />
    </div>
    <iframe
      ref="iframe"
      style="height: 100%; width: 100%; border: none;"
      src="https://heycollab.com/learn-platform/"
      v-show="showIframe"
      allowfullscreen="true"
    >
    </iframe>
  </div>
</template>
<script>
export default {
  name: "LearnView",
  mounted() {
    setTimeout(() => {
      this.showIframe = true;
    }, 2000);
  },
  data() {
    return {
      showIframe: false,
    };
  },
  props: ["drawerRight"],
};
</script>
<style lang="scss" scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: #ffffff;
}
</style>
